<template>
  <div>
    <p class="mb-4" qaid="customization-share-email-dialog-message">
      {{ $t('projectOne.config.summary.email.share') }}
    </p>
    <form @submit.prevent="sendEmail">
      <pdl-form-group
        v-model="emailAddress"
        type="text"
        :name="$t('text.address.email').toLowerCase()"
        :maxlength="200"
        :label="$t('text.address.email')"
        qaid="customization-share-email-dialog-adderess-input"
        :error="getErrorMessage('emailAddress')"
        required
      />

      <pdl-form-group
        v-model="emailMessage"
        type="textarea"
        :name="$t('projectOne.config.summary.email.message').toLowerCase()"
        :maxlength="500"
        row="4"
        :label="$t('projectOne.config.summary.email.message')"
        :required="false"
        qaid="customization-share-email-dialog-message-input"
      />

      <div class="buttons buttons--right">
        <pdl-button qaid="customization-share-email-dialog-save-btn" primary :disabled="!isEnabled" type="submit">
          <span>{{ $t('projectOne.config.summary.email.send') }}</span>
        </pdl-button>

        <pdl-button qaid="customization-share-email-dialog-cancel-btn" secondary @click="handleCancel">
          <span>{{ $t('text.button.cancel') }}</span>
        </pdl-button>
      </div>
    </form>
  </div>
</template>

<script>
import storefrontInstance from '@/api/instances/storefront';
import {mapMutations, mapState} from 'vuex';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {PdlButton} from '@pedal/pdl-button';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
import {SUMMARY_DIALOG_VIEWS} from '@/familyDetailsPage/store/bike-customization.js';

export default {
  name: 'CustomizationShareEmailBody',
  components: {PdlFormGroup, PdlButton},
  mixins: [TrekValidationMixin],
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  data() {
    return {
      emailAddress: '',
      emailMessage: '',
      isEnabled: false,
    };
  },
  validations() {
    return {
      emailAddress: {
        required: this.trekValidators.required('text.address.email'),
        email: this.trekValidators.email('text.address.email'),
      },
    };
  },
  computed: {
    ...mapState('bikeCustomization', ['buildId', 'isCustomizationSummaryDialogOpen']),
  },
  watch: {
    emailAddress() {
      this.v$.$validate().then((isValid) => {
        this.isEnabled = isValid;
      });
    },
  },
  mounted() {
    this.$emit('body-mounted');
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setIsCustomizationShareEmailDialogOpen',
      'setSummaryDialogView',
      'clearQueuedShareAction',
      'setIsProcessingCustomizationAction',
    ]),
    async sendEmail() {
      this.setIsProcessingCustomizationAction(true);
      const emailUrl = `/project-one/api/configurations/${this.buildId}/sendconfigurationemail/`;

      try {
        await storefrontInstance.post(emailUrl, {
          contactEmail: this.emailAddress,
          p1Message: this.emailMessage,
          p1ConfigurationUrl: window.location.href,
        });
      } catch (er) {
        console.error(er);
      } finally {
        if (this.isCustomizationSummaryDialogOpen) {
          this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.BUILD_SUMMARY);
        } else {
          this.setIsCustomizationShareEmailDialogOpen(false);
        }
        this.clearQueuedShareAction();
        this.setIsProcessingCustomizationAction(false);
      }
    },

    handleCancel() {
      this.clearQueuedShareAction();
      if (this.isCustomizationSummaryDialogOpen) {
        this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.BUILD_SUMMARY);
      } else {
        this.setIsCustomizationShareEmailDialogOpen(false);
      }
    },
  },
};
</script>
